export default {
    setUser (state, { user }) {
        state.user = user
    },
    setError (state, { error }) {
        state.error = error
    },
    setBillingHistory (state, { billHistory }) {
        state.billingHistory = billHistory
    },
    setDefaultImages (state, { imagesList }) {
        state.defaultImagesList = imagesList
    },
    setPaypalToken (state, { token }) {
        state.paypalToken = token
    },
    setCreditCardInfo (state, { ccInfo }) {
        state.creditCardInfo = ccInfo
    },
    setUserPlaylists (state, { playlist }) {
        state.userPlaylists = playlist
    },
    setUserSharedPlaylists (state, { playlist }) {
        state.userSharedPlaylists = playlist
    },
    setValidationStatusError (state, flag) {
        state.validationStatusError = flag
    },
    setCorporationPinnedMsgs (state, { msgs }) {
        state.corporationPinnedMsgs = msgs
    },
    setCropUserSharedVideos (state, { vids }) {
        state.corpUserSharedVideos = vids
    },
    setUserPlaylistsProfile (state, { playlists }) {
        state.userPlaylistsProfile = playlists
    },
    setUserProgressProfile (state, { playlists }) {
        state.userProgressProfile = playlists
    },
    setEmailPreferences (state, { pref }) {
        state.userEmailPreferences = pref
    }
}



// WEBPACK FOOTER //
// ./src/store/users/mutations.js